import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import _get from 'lodash/get';
import { callSelectors, networkSelectors, userProfileSelectors } from '@lifesize/nucleus';
import { toggleMinimized } from 'actions/InCall/InCallVideo';
import Header from 'components/InCall/CallHeader';
import { isReconnecting as isReconnectingSelector } from 'selectors/connection';

/**
 * This container will have the mapping of data and controls of call header info.
 * Likely only be a contact name or vmr title.
 */
const mapActionCreators = (dispatch, ownProps) => ({
  toggleMinimized: () => dispatch(toggleMinimized(ownProps.history.push))
});

const mapStateToProps = (state) => {
  const activeCall = callSelectors.activeCallSelector(state);
  const title = _get(activeCall, 'remoteContact.isMeeting') ? activeCall.name : '';
  const isGuest = userProfileSelectors.selectIsGuest(state);
  const enableMinimize = !isGuest;
  const isMinimized = _get(state, 'app.inCallVideo.isMinimized');
  const isOnline = networkSelectors.isOnline(state);
  const { iceRestarting, longRunningRequests } = networkSelectors.connectivity(state);
  const badCallQuality = iceRestarting || longRunningRequests;

  return ({
    title,
    isMinimized,
    enableMinimize,
    videoLayout: _get(state, 'app.inCallVideo.videoLayout'),
    // TODO - revisit when new selector available in Nucleus
    // Feature flag ref: featureSelectors.getFeatureFlag(state)(FLAG_ENABLE_CALL_QUALITY);
    badCallQuality,
    isOnline,
    isReconnecting: isReconnectingSelector(state)
  });
};

export default withRouter(injectIntl(connect(mapStateToProps, mapActionCreators)(Header)));
